/**
 * foundIndex.js
 */

import axios from 'axios'

let foundIndex = null;

function loadFoundIndex() {
    return axios.get(
        '/data/roads/foundIndex.json'
    ).then((response) => {
        if (response.data) {
            foundIndex = response.data;
            return foundIndex
        }
        return false
    }).catch(() => {})
}

function getFoundIndex() {
    return new Promise((resolve) => {
        if (foundIndex) resolve(foundIndex)
        else return loadFoundIndex()
    })
}

export {
    loadFoundIndex,
    getFoundIndex
}